module.exports = __webpack_public_path__ + "assets/img/free_33.d97d0c5d.png";